import React from 'react';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, IconButton } from '@mui/material';

interface NotificationBellButtonProps {
  badgeCount: number;
  isDisabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const NotificationBellButton: React.FC<NotificationBellButtonProps> = ({
  badgeCount,
  isDisabled,
  onClick
}) => (
  <IconButton
    aria-label="Notifications"
    disabled={isDisabled}
    onClick={onClick}
    size="small"
  >
    <Badge
      badgeContent={badgeCount}
      sx={{
        '& .MuiBadge-badge': {
          backgroundColor: 'var(--palette-semantic-background-primary)',
          color: 'white',
          fontSize: '10px',
          fontWeight: 'bold',
          minWidth: '16px',
          height: '16px'
        }
      }}
    >
      <NotificationsIcon
        htmlColor="var(--palette-semantic-icon-secondary)"
        fontSize="small"
      />
    </Badge>
  </IconButton>
);
